import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import HomeCounter from "../hometwo/HomeCounter";

function BreederAdoption() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 1000,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          speed: 1000,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          speed: 1000,
        },
      },
    ],
  };
  return (
    <section className="inner-breeder-area breeder-bg">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-xl-4 col-lg-9 col-md-12 col-sm-9">
            <div className="adoption-content">
              <h5 className="sub-title">Marca la diferencia</h5>
              <h2 className="title">
                Tu <span>Comunidad</span> de mascotas
              </h2>
              <p>
                Ayuda a muchos animalitos a través de nuestra plataforma de
                adopción y rescate. Aquí puedes reportar mascotas perdidas o
                aquellas que hayas encontrado, facilitando su regreso a casa.
                También contamos con una sección dedicada a mascotas en
                adopción, donde puedes descubrir a tu próximo compañero. Realiza
                donaciones para apoyar rescates de mascotas. Juntos, podemos
                transformar la vida de estos animales y brindarles un futuro
                mejor.
              </p>
            </div>
          </div>
          <div className="col-xl-8 col-lg-9 col-md-12 col-sm-9">
            <div className="breeder-info-wrap">
              <div className="row no-gutters justify-content-center">
                <div className="col-md-6">
                  <Slider className="breeder-active slick" {...settings}>
                    <div className="breeder-item">
                      <Link to="/breeder-details">
                        <img src="img/images/breeder_img01.jpg" alt="" />
                      </Link>
                    </div>
                    <div className="breeder-item">
                      <Link to="/breeder-details">
                        <img src="img/images/breeder_img02.jpg" alt="" />
                      </Link>
                    </div>
                    <div className="breeder-item">
                      <Link to="/breeder-details">
                        <img src="img/images/breeder_img03.jpg" alt="" />
                      </Link>
                    </div>
                    <div className="breeder-item">
                      <Link to="/breeder-details">
                        <img src="img/images/breeder_img04.jpg" alt="" />
                      </Link>
                    </div>
                    <div className="breeder-item">
                      <Link to="/breeder-details">
                        <img src="img/images/breeder_img05.jpg" alt="" />
                      </Link>
                    </div>
                  </Slider>
                </div>

                <div className="col-md-6">
                  <div
                    className="breed-services-info"
                    style={{
                      backgroundImage: 'url("img/bg/breed_services_bg.jpg")',
                    }}>
                    <h5 className="sub-title">Galileo Pet House</h5>
                    <h3 className="title">Portal de Mascotas</h3>
                    <p>
                      Encuentra, Adopta, Rescata y Dona. Juntos podemos hacer la
                      diferencia.
                    </p>
                    <div
                      to="/doglist"
                      className="btn"
                      onClick={() =>
                        window.open(
                          "https://www.galileopethouse.com/",
                          "_blank"
                        )
                      }>
                      Más Mascotas <img src="img/icon/w_pawprint.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="counter-area mt-70">
          <HomeCounter />
        </div>
      </div>
    </section>
  );
}
export default BreederAdoption;
